import cn from 'classnames'

import { getQBRFormattedFinance } from '../../../../../../helpers/getQBRFormattedFinance'
import { getQBRFormattedPercent } from '../../../../../../helpers/getQBRFormattedPercent'
import styles from '../PlanAchievement.module.scss'

interface IGetMoneyViewCellParameters {
  actuals: number
  plans: number
  actualsToPlans: number
  yoyActuals: number
  rounding: string
  isTotal?: boolean
  isAlternativeTotal?: boolean
}

export const getMoneyViewCell = ({
  rounding,
  actuals,
  plans,
  actualsToPlans,
  yoyActuals,
  isTotal,
  isAlternativeTotal,
}: IGetMoneyViewCellParameters) => {
  return (
    <div
      className={cn(styles.financialValue, styles.fullView, {
        [styles.total]: isTotal,
        [styles.alternativeTotal]: isAlternativeTotal,
      })}
    >
      <p className={cn(styles.paragraph, styles.actuals)}>
        {getQBRFormattedFinance(actuals, rounding)}
      </p>
      <p className={cn(styles.paragraph, styles.plans)}>
        {getQBRFormattedFinance(plans, rounding)}
      </p>
      <p
        className={cn(styles.subParagraph, {
          [styles.positive]: actualsToPlans > 100,
          [styles.negative]: actualsToPlans < 100,
        })}
      >
        {getQBRFormattedPercent(actualsToPlans)}
      </p>
      <p
        className={cn(styles.subParagraph, {
          [styles.positive]: yoyActuals > 0,
          [styles.negative]: yoyActuals < 0,
          [styles.zero]: yoyActuals === 0,
        })}
      >
        {getQBRFormattedPercent(yoyActuals, 'exceptZero')}
      </p>
    </div>
  )
}
